import {IndebtedLogoWithText} from "@indebted/assets"
import {Box, Typography} from "@mui/material"
import {colors} from "@indebted/theme/colors"

export function IndebtedLogoWithYear() {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				gap: "10px",
				paddingBottom: "2.188rem",
			}}
		>
			<IndebtedLogoWithText alt="InDebted logo" width={100} />
			<Typography variant="body2" color={colors.heron["900"]} textAlign="start" className="amp-mask">
				© 2025
			</Typography>
		</Box>
	)
}
